import SingleSubscriptionContainer from "./SingleSubscriptionContainer";
export default SingleSubscriptionContainer;
